import NotificationRules from './NotificationRules';

export default NotificationRules;
